import React from "react";

export default function Error404() {
  return (
    <div className="p-3 text-center">
      <h2 className="text-primary mb-3 font-weight-light">
        Page not <b>found</b>
      </h2>
      <p className="lead small mb-0">
        Oops! Looks like you followed a bad link.
      </p>
      <p className="mb-5">
        If you think this is a problem with us, please <a href="#">tell us</a>.
      </p>
      <a href="/" className="btn btn-primary">
        Go Back
      </a>
      <a href="/" className="btn btn-light">
        Help
      </a>
    </div>
  );
}
